import React from "react";
import cx from "classnames";
import { css, keyframes } from "react-emotion";
import { Transition } from "react-transition-group";
import { withRedux } from "helpers";

const imageEntrance = keyframes`
  0% {
    transform: translateX(20rem);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
`;

const container = css`
  position: relative;
  height: 10rem;
  margin-bottom: 2rem;
  width: 100%;
  text-align: center;
  transition: transform 0.2s ease-in-out;

  &:hover {
    cursor: pointer;
    /* border: 2px solid red; */
    background: #e7e7e7;
    transform: scale(1.02);
  }
`;

const imageStyle = css`
  width: 100%;
  height: 100%;
  transition: 0.4s;
  object-fit: cover;
`;

const enteringImage = css`
  transform: translate(3rem);
  opacity: 0;
  transition: 0.4s;
`;

const clickActionStyle = css`
  /* &:hover {
    border: 1px solid white;
    cursor: pointer;
  } */
`;

const exitingImage = css`
  transform: translate(-10rem);
  opacity: 0;
`;

class RotatingImageGallery extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      inTransition: false,
      activeIdx: 0,
    };

    this.onClick = this.onClick.bind(this);
  }

  onClick() {
    let {
      actions: { updateActiveEditor },
      componentNumber,
    } = this.props;

    if (componentNumber) {
      updateActiveEditor(componentNumber);
    }
  }

  componentDidMount() {
    this.timer = setTimeout(this.updateImage, 3000);
  }

  componentWillUnmount() {
    clearTimeout(this.timer);
    let { activeEditor } = this.props;

    if (activeEditor) {
      this.props.actions.refreshActiveEditor();
    }
  }

  updateImage = () => {
    const { images } = this.props;
    const maxIdx = images.length - 1;
    this.setState({ inTransition: true });
    this.timer = setTimeout(() => {
      this.setState((prevState) => {
        let newIdx = prevState.activeIdx + 1;
        if (newIdx > maxIdx) newIdx = 0;
        return {
          inTransition: false,
          activeIdx: newIdx,
        };
      });
      this.timer = setTimeout(this.updateImage, 3000);
    }, 500);
  };

  render() {
    const { images, setTemplate } = this.props;
    const { activeIdx, inTransition } = this.state;
    const activeImage = images[activeIdx];

    const clickAction = activeImage && activeImage.clickAction;
    const hasClickAction = clickAction && clickAction.templateId;

    return (
      <div className={container} onClick={this.onClick}>
        {activeImage && (
          <Transition in={!inTransition} timeout={420} unmountOnExit>
            {(state) => (
              <img
                src={
                  activeImage.url
                    ? activeImage.url
                    : "https://mobile360-assets.s3.us-east-2.amazonaws.com/upload.png"
                }
                className={cx(
                  imageStyle,
                  state === "exiting" && exitingImage,
                  state === "entering" && enteringImage,
                  state === "entered" && hasClickAction && clickActionStyle
                )}
                // onClick={state === 'entered' && hasClickAction ? setTemplate(clickAction.templateId) : this.onClick}
              />
            )}
          </Transition>
        )}
      </div>
    );
  }
}

export default withRedux(RotatingImageGallery);
